import type { ReferenceType } from '@cult/domain';
import type { AdminOrderQuery, AdminUserListQuery } from '@cult/schemas';

export const adminKeys = {
  all: ['admin'] as const,
  menuCounters: () => [...adminKeys.all, 'menu', 'counters'] as const,
  users: (filters: AdminUserListQuery) => [...adminKeys.all, 'users', filters] as const,
  reference: (type: ReferenceType) => [...adminKeys.all, 'reference', type] as const,
  domains: () => [...adminKeys.all, 'domains'] as const,
  invites: () => [...adminKeys.all, 'invites'] as const,
  marketSkus: () => [...adminKeys.all, 'market', 'skus'] as const,
  marketSkuOptions: () => [...adminKeys.all, 'market', 'sku-options'] as const,
  marketOrders: (query: AdminOrderQuery) => [...adminKeys.all, 'market', 'orders', query] as const,
  marketOrder: (orderId: string) => [...adminKeys.all, 'market', 'order', orderId] as const,
};
